import CityPageTemplate from "../city-template/CityPageTemplate";
import { southPortlandConfig } from "./data";

export default function SouthPortlandPage() {
  return <CityPageTemplate config={southPortlandConfig} />;
}